import { render, staticRenderFns } from "./InquiryFieldInput.vue?vue&type=template&id=53496a64"
import script from "./InquiryFieldInput.vue?vue&type=script&lang=js"
export * from "./InquiryFieldInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports